// First we need to import axios.js
import axios from 'axios';

let token = sessionStorage.getItem('token');

const instance = axios.create({
    // .. where we make our configurations
        baseURL: 'https://backend.canawho.com'
    });
    
// Where you would set stuff like your 'Authorization' header, etc ...
instance.defaults.headers.common['Authorization'] = token;


export default instance;